import { render } from "./TeilstudiengaengeZuordnungModal.pug?vue&type=template&id=186b49a2&lang=pug"
import script from "./TeilstudiengaengeZuordnungModal.js?vue&type=script&lang=js"
export * from "./TeilstudiengaengeZuordnungModal.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__